export default __webpack_public_path__ + "static/media/icon-compare.bfe57660.svg";